export const SUB_SPECIALTY_CERT_ROUTE_NAME = 'subSpecialtyCertRoutes';
export const SUB_SPECIALTY_CERT_BY_PARENT_ROUTE_NAME = 'subSpecialtyCertByParent';

export const SUB_SPECIALTY_CERTIFICATE_ROUTES = {
  get: 'subspecialty-certifications/by-specialty-board/{specialtyBoardId}',
};

export const SUB_SPECIALTY_CERT_BY_PARENT_ROUTES = {
  get: 'subspecialty-certifications/{specialtyCertificationId}',
};
